import type { DepartmentMetricsDto } from '@ampsec/platform-client';
import type { GroupedProgressItem } from './GroupedProgress';

/**
 * Maps analytics API department metrics to the generic GroupedProgressItem shape.
 * Use this when displaying progress grouped by department (e.g. on the analytics dashboard).
 */
export function mapDepartmentMetricsToGroupedProgress(rows: DepartmentMetricsDto[]): GroupedProgressItem[] {
    return rows.map((row) => {
        const outstanding = Math.max(0, row.count - row.findingsClosed - row.engaged);
        return {
            groupId: row.department,
            groupLabel: row.department,
            completed: row.findingsClosed,
            inProgress: row.engaged,
            outstanding,
            total: row.count,
        };
    });
}
